import { Link } from 'react-router-dom';
import './products.css';

const products = [
  { name: 'Rice Products', image: '/images/products/rice.webp', link: '/rice' },
  { name: 'Oil Products', image: '/images/products/oil.webp', link: '/oil' },
  { name: 'Masala Powder', image: '/images/products/masala.webp', link: '/masala'},
  { name: 'Lentils & Pulses', image: '/images/products/pulse.webp', link: '/lentils' },
  { name: 'Sugars', image: '/images/products/sugar.webp', link: '/sugars' },
  { name: 'Salts', image: '/images/products/salts.webp', link: '/salts' },
  { name: 'Dried Rice Fryums', image: '/images/products/dryrice.webp', link:'/dryrice' },
  { name: 'Flours', image: '/images/products/flours.webp', link: '/flours' },
  { name: 'Pickles', image: '/images/products/pickles.webp', link: '/pickles' },
  { name: 'Ready Mix', image: '/images/products/sauces.webp',link: '/sauces'},
  { name: 'Millets', image: '/images/products/millets.webp', link: '/millets' },
  { name: 'Sun Dried Vegetables', image: '/images/products/sundried.webp', link: '/sundry' },
  { name: 'Cereals', image: '/images/products/cereals.webp', link: '/cereals'},
  { name: 'Claypots', image: '/images/products/pots.webp', link: '/pots'}
];

const Products = () => {
  return (
    <section className="products">
      <h1>Our Products</h1>

      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>

      <div className="product-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            {product.link ? (
              <Link to={product.link}>
                <img src={product.image} alt={product.name} />
              </Link>
            ) : (
              <img src={product.image} alt={product.name} />
            )}
            <div className="product-name">{product.name}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Products;
